import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';

import {PoDynamicFormField, PoLookupColumn, PoLookupFilter, PoLookupFilteredItemsParams} from '@po-ui/ng-components';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TransportadoraService implements PoLookupFilter {
  url = `${environment.urlApiProtheus}/wsrtransportadora`;

  constructor(private httpClient: HttpClient) {
  }

  getFilteredItems(filteredParams: PoLookupFilteredItemsParams): Observable<any> {
    const {filterParams, advancedFilters, ...restFilteredItemsParams} = filteredParams;
    const params = {...restFilteredItemsParams, ...filterParams, ...advancedFilters};

    return this.httpClient.get(this.url, {params});
  }

  getObjectByValue(value: string): Observable<any> {
    return this.httpClient.get(`${this.url}/${value}`);
  }

  getAdvancedFilter(): Array<PoDynamicFormField> {
    return [
      {property: 'CA4COD'  , optional: true, gridColumns: 3 , label: 'Código'},
      {property: 'CA4NOME' , optional: true, gridColumns: 12, label: 'Nome'},
      {property: 'CA4CGC'  , optional: true, gridColumns: 6 , label: 'CNPJ'},
      {property: 'CA4EST'  , optional: true, gridColumns: 3 , label: 'Estado'},
    ];
  }

  getColumnsFilter(): Array<PoLookupColumn> {
    return [
      {property: 'CA4COD'   , label: 'Código'},
      {property: 'CA4NOME'  , label: 'Nome'},
      {property: 'CA4CGC'   , label: 'CNPJ'},
      {property: 'CA4EST'   , label: 'Estado'},
    ];
  }

  getFieldFormater(value: any): string {
    return `${value.CA4COD} - ${value.CA4NOME}`;
  }
}
